import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';

const getDisplayName = (appliedFilters, stores) => {
  if (appliedFilters.length === 0) {
    return <FormattedMessage defaultMessage='Store' description='filterOptions.store' id='gwPKWT' />;
  }
  if (appliedFilters.length > 1) {
    return <FormattedMessage defaultMessage='(Multiple Stores)' description='filterOptions.multipleStores' id='ueLluZ' />;
  }
  const [filter] = appliedFilters;
  const matchingStore = stores.find((store) => store.storeGuid === filter.criterionArgumentValue);
  if (!matchingStore) {
    return <FormattedMessage defaultMessage='Store' description='filterOptions.store' id='gwPKWT' />;
  }
  return matchingStore.name;
};

const mapStateToProps = (state, ownProps) => {
  const stores = Global.selectSellerActiveStores(state);
  const appliedFilters = Global.selectShipmentsFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });

  return {
    isSelected: !!appliedFilters.length,
    displayContent: getDisplayName(appliedFilters, stores),
  };
};

export const Store = connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
